export default __webpack_public_path__ + "static/media/ae3d3974db638e858d0a2a20a9d408e5.jpg";